import { handleActions } from 'redux-actions'
import update from 'immutability-helper'
import * as actions from './notification.actions'

const initialState = {
    msgList: [],
    msgTotal: 0,
    msgReadTotal: 0,
}

// export type NotificationState = Readonly<typeof initialState>
export interface NotificationState {
    msgList: any,
    msgTotal: any,
    msgReadTotal: any
}


export default handleActions<any>({
    [actions.RECEIVE_MSG_LIST]: (state: any, { payload }) => {
        return update(state, {
            msgList: { $set: (payload as any).data.data },
            [`${(payload as any).type}Total`]: { $set: (payload as any).data.totalNumber}
        })
    }
}, initialState)